import { QueryClient } from "@tanstack/react-query";

/**
 * One application query client.
 *
 * Queries keep the existing read policy (staleTime 0, one retry). Mutations are explicitly
 * `networkMode: "always"`: with react-query's default ("online") a mutation attempted while the
 * browser is offline is paused and then replayed automatically on reconnect. For this product a
 * mutation can be a state-changing operator action, so a silent replay after a reconnect is a
 * duplicate-action path. "always" makes the attempt fail visibly now, and the operator decides
 * whether to retry; nothing is queued for automatic replay.
 */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 0, retry: 1 },
      mutations: { networkMode: "always", retry: 0 },
    },
  });
}

export default createQueryClient;
